module.exports = __webpack_public_path__ + "img/index-new-04.96484124.svg";